import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFarms, useLots, createInventoryLocal } from "@/lib/repo";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function NewInventory() {
  const navigate = useNavigate();
  const farms = useFarms();
  const [form, setForm] = useState({ farm_id: "", lot_id: "", name: "" });
  const lots = useLots(form.farm_id);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (farms[0] && !form.farm_id) setForm((s) => ({ ...s, farm_id: farms[0].id }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [farms]);

  const start = async () => {
    if (!form.farm_id) return toast.error("Elegí una finca");
    setLoading(true);
    try {
      const inv = await createInventoryLocal({
        farm_id: form.farm_id,
        lot_id: form.lot_id || null,
        name: form.name || null,
      });
      navigate(`/inventario/${inv.id}/sesion`);
    } catch (e) {
      toast.error(e?.userMessage || "No pude iniciar");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" onClick={()=>navigate(-1)} className="h-9 px-2" data-testid="new-inventory-back"><ArrowLeft size={18} /></Button>
        <h1 className="font-heading text-2xl font-semibold">Iniciar inventario</h1>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-base">Elegí dónde</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <div>
            <Label>Finca</Label>
            <Select value={form.farm_id} onValueChange={(v)=>setForm({ ...form, farm_id: v, lot_id: "" })}>
              <SelectTrigger className="h-11" data-testid="new-inventory-farm"><SelectValue placeholder="Elegir finca" /></SelectTrigger>
              <SelectContent>{farms.map((f)=><SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Lote (opcional)</Label>
            <Select value={form.lot_id || "all"} onValueChange={(v)=>setForm({ ...form, lot_id: v === "all" ? "" : v })}>
              <SelectTrigger className="h-11" data-testid="new-inventory-lot"><SelectValue placeholder="Todos los lotes" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos los lotes</SelectItem>
                {lots.map((l) => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Nombre (opcional)</Label>
            <Input data-testid="new-inventory-name" value={form.name} onChange={(e)=>setForm({ ...form, name: e.target.value })} className="h-11" placeholder="Conteo octubre" />
          </div>
          <Button data-testid="new-inventory-start" onClick={start} disabled={loading} className="h-12 w-full bg-emerald-700 hover:bg-emerald-800">
            {loading ? "Iniciando…" : "Iniciar inventario"}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
